import styled from "@emotion/styled";

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;

  @media (max-width: 767px) {
    position: static;
    flex: 0 0 auto;
  }
`;

const FooterContainer = styled.footer`
  background-color: #0B3E5F;
  color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 44px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);

 @media (max-width: 767px) {
    box-sizing: border-box;
    min-height: auto;
    padding: 12px 16px;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;

  a {
    color: #cdcdcd;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.17px;
    font-family: "Poppins", sans-serif;
    text-align: center;
    white-space: nowrap;
    
    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-wrap: wrap;
    gap: 1rem;

    a {
      font-size: 10px;
      white-space: normal;
    }
  }
`;

const Footer = () => {

  return (
    <FooterWrapper>
      <FooterContainer>
        <FooterLinks>
          <a
            href="https://www.emergencias.com.ar/"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.emergencias.com.ar
          </a>
          <a
            href="https://emergencias.sd.cloud.invgate.net/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Necesito reportar un problema
          </a>
          <a
            href="https://www.argentina.gob.ar/salud/digital"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.argentina.gob.ar/salud/digital
          </a>
        </FooterLinks>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer;
